import { Repository } from '../servics/httpsServics';

// Get all available projects
export function getAllProjects(interpreterId) {
  return Repository.get(`/stai2/projects?interpreter=${interpreterId}`);
}

export function getProjectById(id) {
  return Repository.get(`/stai2/projects/${id}`);
}
